export default "__VITE_ASSET__Cyz4EGBW__"